import primaryButton from '../../../../primary-button';

const secondary = (params) => primaryButton.solidIcon.background.hover.secondary(params);

export default secondary;
